<template>
    <t-space direction="horizontal" style="width: 100%; padding-top: 5vh;">
        <t-space></t-space>
        <t-card style=" width: 85.5vw; max-height: 88vh; height: 88vh;" title="聊天框">
            <t-chat
                class="chart-content"
                :clear-history="false"
                :reverse="true"
                :text-loading="loading"
                :data="data">   
                <template #footer>
                    <t-tooltip content="选择后会思考的比较久哦，请耐心等待">
                        <div :class="tagClass()" @click="()=>{choseTag = !choseTag}">业务深思</div>
                    </t-tooltip>
                    <t-chat-input 
                        :stop-disabled="isStreamLoad" 
                        @send="inputEnter" 
                        @stop="handleStop"
                        :textarea-props="{
                                placeholder: '请输入消息...',
                        }"> 
                    </t-chat-input>
                    <!-- <t-chat-sender                 
                        :stop-disabled="isStreamLoad" 
                        @send="inputEnter" 
                        @stop="handleStop"
                        :textarea-props="{
                                placeholder: '请输入消息...',
                        }">
                        <template #prefix>
                            <t-button class="check-box" :class="{ 'is-active': isChecked }" variant="text" @click="checkClick">
                                <SystemSumIcon />
                                <span>深度思考</span>
                            </t-button>
                        </template>
                    </t-chat-sender> -->
                </template>
            </t-chat>
        </t-card>
        <t-space></t-space>
    </t-space>

</template>

<script setup>
import { ref } from 'vue';
// import request from '@/request/request';
import { NotifyPlugin } from 'tdesign-vue-next';

const choseTag = ref(false);
const loading = ref(false);
const isStreamLoad = ref(false);
const data = ref([
    {
        avatar: '/avatar33.png',
        content: '你好啊，很高兴你可以关注我，请问我有什么可以帮助你的吗？',
        role: 'assistant',
    }
])

const tagClass = function(){
    if(choseTag.value)  return 'tags-click'
    return 'tags'
}
console.log(tagClass)

const handleStop = function () {
    isStreamLoad.value = false;
};

// 模拟消息发送
const inputEnter = async function (inputValue) {
    data.value.unshift({
        avatar: '/avatar15.png',
        content: inputValue,
        role: 'user',
    });
    data.value.unshift({
        avatar: '/avatar33.png',
        content: '',
        role: 'assistant',
    });
    if (isStreamLoad.value) {
        return;
    }
    if (!inputValue) return;
    isStreamLoad.value = true;
    loading.value = true;
    try {
        if(choseTag.value) {
            await fetchAiTagStream(inputValue);
        } else {
            await fetchAi(inputValue);
        }
    } catch (err) {
        console.error('请求出错:', err);
        NotifyPlugin.error({
            title: "服务器繁忙请稍后重试",
            message: "服务器繁忙请稍后重试" + err,
            duration: 3000
        });
    }
};

const fetchAi = (message) => {
    return new Promise((resolve, reject) => {
        const eventSource = new EventSource(`flash_warehouse/ai/qwen_plus/stream?message=${message}&binding_user_id=${parseInt(sessionStorage.getItem("user_id"))}`);
        eventSource.onmessage =async (event) => {
            console.log('接收到事件:', event);
            try {
                const dataChunk = JSON.parse(event.data);
                console.log('接收到的数据块:', dataChunk); 
                if (dataChunk && dataChunk.choices && dataChunk.choices.length > 0) {
                    const content = dataChunk.choices[0].delta.content;
                    if (content) {
                        setTimeout(() => {
                            data.value[0].content += content;
                        }, 2000);
                        // data.value[0].content += content;
                    }
                }
            } catch (error) {
                console.error('解析流式数据出错:', error);
            }
        };
        eventSource.onerror = (error) => {
            console.error('流式请求出错:', error);
            eventSource.close();
            loading.value = false;
            isStreamLoad.value = false;
            NotifyPlugin.error({
                title: "服务器繁忙请稍后重试",
                message: "服务器繁忙请稍后重试" + error,
                duration: 3000
            });
            reject(error);
        };
        eventSource.onopen = () => {
            console.log('流式请求已打开');
        };
        eventSource.onclose = () => {
            console.log('流式请求已关闭');
            loading.value = false;
            isStreamLoad.value = false;
            resolve();
        };
    });
}

const  fetchAiTagStream = async (message) => {
    return new Promise((resolve, reject) => {
        const eventSource = new EventSource(`flash_warehouse/ai/qwen_plus/tag/stream?message=${message}&binding_user_id=${parseInt(sessionStorage.getItem("user_id"))}`);
        eventSource.onmessage =async (event) => {
            setTimeout(()=>{
                console.log('接收到事件:', event);
                console.log('Received:', Date.now(), event.data);
                try {
                    const dataChunk = JSON.parse(event.data);
                    console.log('接收到的数据块:', dataChunk); 
                    if (dataChunk && dataChunk.choices && dataChunk.choices.length > 0) {
                        const content = dataChunk.choices[0].delta.content;
                        if (content) {
                            setTimeout(() => {
                                data.value[0].content += content;
                            }, 2000);
                            // data.value[0].content += content;
                        }
                    }
                } catch (error) {
                    console.error('解析流式数据出错:', error);
                }
            },0)
        };
        eventSource.onerror = (error) => {
            console.error('流式请求出错:', error);
            eventSource.close();
            loading.value = false;
            isStreamLoad.value = false;
            NotifyPlugin.error({
                title: "服务器繁忙请稍后重试",
                message: "服务器繁忙请稍后重试" + error,
                duration: 3000
            });
            reject(error);
        };
        eventSource.onopen = () => {
            console.log('流式请求已打开');
        };
        eventSource.onclose = () => {
            console.log('流式请求已关闭');
            loading.value = false;
            isStreamLoad.value = false;
            resolve();
        };
    });
};

</script>


<style scoped>
.chart-content {
    background-color: #fff;
    padding: 1vw;
    height: 80vh;
    width: 100%;
    position: relative;
    z-index: 1;
}

.tags{
    width: 100px;

    text-align: center;
    background-color: #fff;
    border: 1px solid #0052d9;
    color: #0052d9;
    border-radius: 15px;
}

.tags:hover{
    font-weight: 700;
}

.tags-click{
    width: 100px;
    text-align: center;
    background-color: #0052d9;
    border: 1px solid #0052d9;
    color: #fff;
    border-radius: 15px;
}

.tags-click:hover{
    font-weight: 700;
}


.chat-box {
  position: relative;
  .bottonBtn {
    position: absolute;
    left: 50%;
    margin-left: -20px;
    bottom: 210px;
    padding: 0;
    border: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08), 0px 16px 24px 2px rgba(0, 0, 0, 0.04),
    0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  }
  .to-bottom {
    width: 40px;
    height: 40px;
    border: 1px solid #dcdcdc;
    box-sizing: border-box;
    background: var(--td-bg-color-container);
    border-radius: 50%;
    font-size: 24px;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .t-icon {
      font-size: 24px;
    }
  }
}


.model-select {
    display: flex;
    align-items: center;
}

.model-select .t-select {
    width: 112px;
    height: var(--td-comp-size-m);
    margin-right: var(--td-comp-margin-s);
    .t-input {
        border-radius: 32px;
        padding: 0 15px;
    }
    .t-input.t-is-focused {
        box-shadow: none;
    }
}

.model-select .check-box {
    width: 112px;
    height: var(--td-comp-size-m);
    border-radius: 32px;
    border: 0;
    background: var(--td-bg-color-component);
    color: var(--td-text-color-primary);
    box-sizing: border-box;
    flex: 0 0 auto;

}

.model-select  .check-box.is-active {
    border: 1px solid var(--td-brand-color-focus);
    background: var(--td-brand-color-light);
    color: var(--td-text-color-brand);
}

.model-select .check-box  .t-button__text {
    display: flex;
    align-items: center;
    justify-content: center;

}

.model-select .check-box  .t-button__text       span {
    margin-left: var(--td-comp-margin-xs);
}
</style>